module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-amplify/node_modules/axios/index.js
// module id = 1149
// module chunks = 0